import type { Handler } from './handler';
import type {
  ApiPostGiratudoParticipatePort,
  RaffleParticipateResult,
} from './ports/api-post-giratudo-participate.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const postGiratudoParticipateHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiPostGiratudoParticipate: resolveAdapter('apiPostGiratudoParticipate'),
  },
) => {
  const [result, error] = await tryCatch(
    ports.apiPostGiratudoParticipate.handle(params.userId, params.username),
  );

  if (error) {
    const isTimeout = (error as Error).name === 'AbortError';
    const message = isTimeout
      ? 'Tempo limite excedido. Tente novamente.'
      : ((error as Error).message ?? 'Erro ao participar do sorteio.');

    return { ticketNumber: null, error: message };
  }

  return {
    ticketNumber: (result as RaffleParticipateResult).ticketNumber,
    error: null,
  };
};

type Params = { userId: number; username?: string };

type Ports = { apiPostGiratudoParticipate: ApiPostGiratudoParticipatePort };

type Result = Promise<
  { ticketNumber: string; error: null } | { ticketNumber: null; error: string }
>;
